import axios, { AxiosInstance } from 'axios';
import IDays from '../interfaces/IDays';

export const MOBILE = 'phone';
export const BOX = 'box';
export const TABLET = 'tablet';
export const CONNECTETED_DEVICE = 'connectedDevice';
export const MANUAL = 'manuel';
export const AUTOMATIC = 'automatique';

export const BOUTIQUE = 'boutique';
export const POSTE = 'poste';

export const DAYS: IDays = [ 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche' ];

export const TC_EVENT_COMMON_DATA = {
  env: 'DEV',
  site: 'Assistance',
  univers: 'SAV',
  parcours: 'Depannage_en_ligne'
};

export const apiClient: AxiosInstance = axios.create({
  baseURL: 'https://api.review.cordongroup.com/sav-e-diag',
  headers: {
    Accept: 'application/json',
  },
});

export const GOOGLE_MAPS_API_KEY = 'AIzaSyAaMr4sitefb1fOwLYnDRp0CU7-YjRJG-Q';
export const apiAddressFrenchGouvClient: AxiosInstance = axios.create({
  baseURL: 'https://api-adresse.data.gouv.fr',
  headers: {
    Accept: 'application/json'
  },
});

export const getDevice = (deviceType: string|null) : string =>
{
  switch (deviceType) {
    case MOBILE:
      return 'téléphone';
    case  BOX:
      return '4G/5G box ou clé 4G';
    case  TABLET:
      return 'tablette';
    case  CONNECTETED_DEVICE:
      return 'objet connecté';
    default:
      return 'appareil';
  }
};